// Copyright (c) Bentley Systems
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";
import { BrowserAuthorizationClient } from "@itwin/browser-authorization";

type AuthorizationState = {
  loggedIn: boolean;
  authorizationClient: BrowserAuthorizationClient | undefined;
  accessToken: string;
}

const initialState: AuthorizationState = {
  loggedIn: false,
  authorizationClient: undefined,
  accessToken: "",
};

export const authorizationSlice = createSlice({
  name: "authorization",
  initialState,
  reducers: {
    setAuthorizationClient: (
      state,
      action: PayloadAction<BrowserAuthorizationClient>
    ) => {
      state.authorizationClient = action.payload;
      state.loggedIn = state.authorizationClient.isAuthorized;
    },
    setIsLoggedIn: (state, action: PayloadAction<boolean>) => {
      state.loggedIn = action.payload;
    },
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
    },
  },
});

export const { setAuthorizationClient, setIsLoggedIn, setAccessToken } =
  authorizationSlice.actions;

export const selectIsLoggedIn = (state: RootState) => {
  if (state.authorization.authorizationClient)
    {return state.authorization.authorizationClient.isAuthorized;}
  return false;
};
export const selectAuthorizationClient = (state: RootState) =>
  state.authorization.authorizationClient;
export const selectAccessToken = (state: RootState) =>
  state.authorization.accessToken;

export default authorizationSlice.reducer;
